import * as apiActions from '../api/apiActions';
import { MAZE } from '../../constants/measure';

class AssessmentFormsServiceClient {

    static SECURE_FORM_ENDPOINT = '/assessment-forms-api/v1/secure-forms';

    static constructSecureFormEndpoint(formId, year) {
        return `${AssessmentFormsServiceClient.SECURE_FORM_ENDPOINT}/${formId}?school_year=${year}&assessment_name=${MAZE.MEASURE}`;
    }

    static getSecureForm = (formId, year, retryActionName ) => (dispatch) => {
        const endpoint = AssessmentFormsServiceClient.constructSecureFormEndpoint(formId, year);
        return dispatch(apiActions.makeCacheableRetriableGetContentRequest(endpoint, retryActionName));
    }
}

export default AssessmentFormsServiceClient;
